import React from "react";
import { Box, Paper, Container, Typography } from "@mui/material";
import achiev1 from "../../images/achiev1.jpeg";
import achiev2 from "../../images/achiev2.jpeg";
import achiev3 from "../../images/achiev3.webp";
import achiev4 from "../../images/achiev4.webp";
import achiev5 from "../../images/achiev5.webp";

const Accomplishment = () => (
  <Container maxWidth="xl" sx={{ py: 8 }}>
    <Typography
      variant="h2"
      align="center"
      gutterBottom
      sx={{
        fontWeight: 700,
        mb: 6,
        position: "relative",
        fontFamily: "Poppins, sans-serif",
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: -16,
          left: "50%",
          transform: "translateX(-50%)",
          width: "80px",
          height: "4px",
          backgroundColor: "primary.main",
          borderRadius: "2px",
        },
      }}
    >
      Accomplishments
    </Typography>

    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: `center`,
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 2,
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Paper
            elevation={2}
            sx={{
              borderRadius: 2,
              overflow: "hidden",
              width: 350,
              height: 300,
            }}
          >
            <Box
              component="img"
              src={achiev1}
              alt="Achievement 1"
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Paper>

          <Paper
            elevation={2}
            sx={{
              borderRadius: 2,
              overflow: "hidden",
              width: 400,
              height: 300,
            }}
          >
            <Box
              component="img"
              src={achiev2}
              alt="Achievement 2"
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Paper>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* <Paper
        elevation={2}
        sx={{ borderRadius: 2, overflow: "hidden", width: 450, height: 400 }}
      >
        <Box
          component="img"
          src={achiev3}
          alt="Achievement 3"
          sx={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </Paper> */}
          {/* <Paper
        elevation={2}
        sx={{ borderRadius: 2, overflow: "hidden", width: 400, height: 300 }}
      >
        <Box
          component="img"
          src={achiev4}
          alt="Achievement 4"
          sx={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </Paper> */}
        </Box>
      </Box>

      {/* <Paper
          elevation={2}
          sx={{ borderRadius: 2, overflow: "hidden", width: 400, height: 600 }}
        >
          <Box
            component="img"
            src={achiev5}
            alt="Achievement 5"
            sx={{ width: "full", height: "100%", objectFit: "contain", }}
          />
        </Paper> */}
    </Box>
  </Container>
);

export default Accomplishment;
